import { Button, Group, Text } from '@mantine/core';

import { useCloneProphetPageForm } from '../../hooks/useCloneProphetPageForm';

import { RulesSelect, ProphetPagesSelect } from '@/components';
import { Departments, Platforms } from '@/types';

type Props = {
  onSubmit: (data: { rules: string[] }) => void;
  isLoading: boolean;
  department: Departments;
  platform: Platforms;
  pageId: string;
};

export const ClonePageForm = ({ onSubmit, pageId, isLoading, platform, department }: Props) => {
  const form = useCloneProphetPageForm();

  return (
    <form onSubmit={form.onSubmit(({ rules }) => onSubmit({ rules }))}>
      <Text mt="sm" mb="xs" size="sm">
        Page to clone
      </Text>
      <ProphetPagesSelect
        required
        onSelect={(value) => form.setFieldValue('pageId', value)}
        department={department}
        platform={platform}
        disabled={[pageId]}
      />
      <Text mb="xs" mt="xl" size="sm">
        Rules to clone
      </Text>
      <RulesSelect
        pageId={form.values.pageId}
        onSelect={(value) => form.setFieldValue('rules', value)}
      />
      <Group mt="xl" justify="right">
        <Button loading={isLoading} type="submit">
          Clone
        </Button>
      </Group>
    </form>
  );
};
